
import LAB from './LAB'
import LIFEBANK_ACTIONS from './LIFEBANK_ACTIONS'
import ADULT_SELL_ORDER from './ADULT_SELL_ORDER'
import ADULT_LIFEBANK_ACTIONS from './ADULT_LIFEBANK_ACTIONS'
export default [
  LAB,
  LIFEBANK_ACTIONS,
  ADULT_SELL_ORDER,
  ADULT_LIFEBANK_ACTIONS
]
